import React, { useState } from 'react';
import { Button, Group, Text } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';
import ImportDraftService, { errorMessage, isApiError } from '@/services/import-draft/import-draft-service';
import useInlineProcessing from './useInlineProcessing';

interface Props {
  importID: string;
}

export default function ProcessNowButton({ importID }: Props) {
  const enabled = useInlineProcessing();
  const [state, setState] = useState<'idle' | 'starting' | 'started'>('idle');
  const [error, setError] = useState<string | null>(null);

  if (!enabled) return null;

  async function start() {
    setState('starting');
    setError(null);
    const response = await ImportDraftService.processImportNow(importID);
    if (isApiError(response)) {
      setError(errorMessage(response, 'The import could not be started.'));
      setState('idle');
      return;
    }
    setState('started');
  }

  return (
    <Group gap="sm" data-testid="process-now">
      <Button
        variant="light"
        color="orange"
        leftSection={<IconPlayerPlay size={16} />}
        onClick={start}
        loading={state === 'starting'}
        disabled={state === 'started'}
      >
        Run the import now
      </Button>
      <Text size="xs" c={error ? 'red' : 'dimmed'}>
        {error || (state === 'started'
          ? 'The import has started. Progress is shown on the Imports page.'
          : 'The import has been queued. Press to run it straight away.')}
      </Text>
    </Group>
  );
}
